import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[selectOnClick]',
    standalone: true
})
export class SelectOnClickDirective {
    @HostListener('click')
    onClick() {
        if (this.el.nativeElement.tagName === 'INPUT') {
            this.el.nativeElement.select();
        } else {
            const inputChild = this.el.nativeElement.querySelector('input');
            if (inputChild) {
                inputChild.select();
            }
        }
    }

    constructor(private el: ElementRef) {}
}
